<!-- <link href='https://unpkg.com/boxicons@2.1.4/css/boxicons.min.css' rel='stylesheet'> -->
      <!-- bradcam_area  -->
      <div class="bradcam_area bradcam_bg_2" id="goToTop">
        <div class="container">
            <div class="row">
                <div class="col-xl-12">
                    <div class="bradcam_text">
                        <h4>Available House</h4>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!--/ bradcam_area  -->



    <div class="container container_">

        <h1> House gallery</h1>
        
        <div class="Scrollmenu">
            <a href="#home">Home</a>
            <a href="#news">News</a>
            <a href="#contact">Contact</a>
            <a href="#about">About</a>
            <a href="#support">Support</a>
            <a href="#blog">Blog</a>
            <a href="#tools">Tools</a>
            <a href="#base">Base</a>
            <a href="#custom">Custom</a>
            <a href="#more">More</a>
            <a href="#logo">Logo</a>
            <a href="#friends">Friends</a>
            <a href="#parteners">Parteners</a>
            <a href="#people">People</a>
            <a href="#work">Work</a>
        </div>
        <div class="image-container" >

            <!-- <div class="image" *ngFor="let index of [1,2,3,4,5,6]"><img  src="{{'./../../../assets/img/house/img-' + index +'.jpg'}}" alt="" (click)="houseLoan()"><div>100$ ChateauGay</div></div> -->
        </div>
        <!-- <div class="popup-image">
            <span (click)="closeImage()">&times;</span>
            <img style="height: 40%;" src="{{'./../../../assets/img/house/img-' + imgId +'.jpg'}}" alt="">
        </div> -->
        <br>
    </div>


    
<!-- <div class="all">
    <input type="radio" name="photots" id="check1" checked> 
    <input type="radio" name="photots" id="check2" > 
    <input type="radio" name="photots" id="check3" > 
    <input type="radio" name="photots" id="check4" > 

    <div class="container">
            <h1>OUR PHOTO GALLERY</h1>
            <div class="top-content" style="scroll-behavior: auto;">
                <h3>Photos Gallery</h3>
                <label for="check1">All Photos</label>
                <label for="check2">Family Photos</label>
                <label for="check3">Childs Photos</label>
                <label for="check4">Visited Places</label>
            </div>

            <div class="photo-gallery">
                <div class="pic place">
                    <img src="./../../../assets/img/house/img-1.jpg">
                </div>
                <div class="pic family">
                    <img src="./../../../assets/img/house/img-2.jpg">
                </div>
                <div class="pic child">
                    <img src="./../../../assets/img/house/img-3.jpg">
                </div>
                <div class="pic place">
                    <img src="./../../../assets/img/house/img-4.jpg">
                </div>
                <div class="pic family">
                    <img src="./../../../assets/img/house/img-5.jpg">
                </div>
                <div class="pic child">
                    <img src="./../../../assets/img/house/img-6.jpg">
                </div>
                <div class="pic place">
                    <img src="./../../../assets/img/house/img-1.jpg">
                </div>
                <div class="pic family">
                    <img src="./../../../assets/img/house/img-2.jpg">
                </div>
                <div class="pic child">
                    <img src="./../../../assets/img/house/img-3.jpg">
                </div>
                <div class="pic place">
                    <img src="./../../../assets/img/house/img-4.jpg">
                </div>
                <div class="pic family">
                    <img src="./../../../assets/img/house/img-5.jpg">
                </div>
                <div class="pic child">
                    <img src="./../../../assets/img/house/img-6.jpg">
                </div>
                <div class="pic place">
                    <img src="./../../../assets/img/house/img-1.jpg">
                </div>
                <div class="pic family">
                    <img src="./../../../assets/img/house/img-2.jpg">
                </div>
                <div class="pic child">
                    <img src="./../../../assets/img/house/img-3.jpg">
                </div>
                <div class="pic place">
                    <img src="./../../../assets/img/house/img-4.jpg">
                </div>
            </div>
    </div>
</div>  -->


<!-- <div class="all">
    <h1> House gallery</h1>
    <div class="gallery">
        <a href="./../../../assets/img/house/img-1.jpg" data-lightbox="mygallerie" data-title="house to loan"><img src="./../../../assets/img/house/img-1.jpg"></a>
        <a href="./../../../assets/img/house/img-2.jpg" data-lightbox="mygallerie"><img src="./../../../assets/img/house/img-2.jpg"></a>
        <a href="./../../../assets/img/house/img-3.jpg" data-lightbox="mygallerie"><img src="./../../../assets/img/house/img-3.jpg"></a>
        <a href="./../../../assets/img/house/img-4.jpg" data-lightbox="mygallerie"><img src="./../../../assets/img/house/img-4.jpg"></a>
        <a href="./../../../assets/img/house/img-5.jpg" data-lightbox="mygallerie"><img src="./../../../assets/img/house/img-5.jpg"></a>
        <a href="./../../../assets/img/house/img-6.jpg" data-lightbox="mygallerie"><img src="./../../../assets/img/house/img-6.jpg"></a>
        <a href="./../../../assets/img/house/img-1.jpg" data-lightbox="mygallerie"><img src="./../../../assets/img/house/img-1.jpg"></a>
        <a href="./../../../assets/img/house/img-2.jpg" data-lightbox="mygallerie"><img src="./../../../assets/img/house/img-2.jpg"></a>
        <a href="./../../../assets/img/house/img-3.jpg" data-lightbox="mygallerie"><img src="./../../../assets/img/house/img-3.jpg"></a>
        <a href="./../../../assets/img/house/img-4.jpg" data-lightbox="mygallerie"><img src="./../../../assets/img/house/img-4.jpg"></a>
    </div>
</div> -->
   
<!-- <div class="all">
    <body>
        <div class="sidebar">
            <div class="logo_content">
                <div class="logo">
                    <i class='bx bxl-c-plus-plus'></i>
                    <div class="logo_name">CodingLab</div>
                </div>
                <i class='bx bx-menu-alt-left' id="btn"></i>
            </div>
            <ul class="nav_list">

                <li>
                    <a href="#">
                        <i class='bx bx-search'></i>
                        <input type="text" placeholder="Search ...">
                        <span class="tooltip">Search</span>
                    </a>
                </li> 
                <li>
                    <a href="#">
                        <i class='bx bx-grid-alt'></i>
                        <span class="links_name">Dashboard</span>
                        <span class="tooltip">Dashboard</span>
                    </a>
                </li>
                <li>
                    <a href="#">
                        <i class='bx bx-user'></i>
                        <span class="links_name">User</span>
                        <span class="tooltip">User</span>
                    </a>
                </li>
                <li>
                    <a href="#">
                        <i class='bx bx-chat'></i>
                        <span class="links_name">Messages</span>
                        <span class="tooltip">Messages</span>
                    </a>
                </li>
                <li>
                    <a href="#">
                        <i class='bx bxs-pie-chart-alt-2'></i>
                        <span class="links_name">Analytics</span>
                        <span class="tooltip">Analytics</span>
                    </a>
                </li>
                <li>
                    <a href="#">
                        <i class='bx bxs-folder'></i>
                        <span class="links_name">File</span>
                        <span class="tooltip">File Manager</span>
                    </a>
                </li>
                <li>
                    <a href="#">
                        <i class='bx bx-cart-download'></i>
                        <span class="links_name">Order</span>
                        <span class="tooltip">Order</span>
                    </a>
                </li>
                <li>
                    <a href="#">
                        <i class='bx bx-heart'></i>
                        <span class="links_name">Saved</span>
                        <span class="tooltip">Saved</span>
                    </a>
                </li>
                <li>
                    <a href="#">
                        <i class='bx bx-cog'></i>
                        <span class="links_name">Setting</span>
                        <span class="tooltip">Setting</span>
                    </a>
                </li>     

            </ul>
            <div class="profile_content">
                <div class="profile">
                    <div class="profile_details">
                        <div class="name_job">
                            <div class="name">Eric vofack</div>
                            <div class="job">Web design</div>
                        </div>
                    </div>
                    <i class='bx bxs-log-out' id="log_out"></i>
                </div>
            </div>
        </div>
        <div class="home_content">
            <div class="text">Home content</div>
        </div>
    </body>
</div> -->